import { capitalize } from 'helpers/Capitalize';

import { ChevronDownIcon } from 'icons/ChevronIcon';

import { ANALYSELANGAUGESLIST } from 'utils/Constants';

export const LanguageDropdown = ({ t, setLanguage, language }) => {
  return (
    <div className="box-list-dropdown">
      {t('Langue')}:
      <div className="dropdown" style={{ width: 170, marginLeft: 5 }}>
        <button
          className="btn dropdown-toggle dropdown-custom w-100"
          type="button"
          id="dropdownMenuButton1"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          {t(capitalize(language.language.toLowerCase()))}
          <span>
            <ChevronDownIcon />
          </span>
        </button>
        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
          {' '}
          {ANALYSELANGAUGESLIST.map((item, index) => (
            <li key={index}>
              <button
                className="dropdown-item"
                onClick={() => setLanguage(item)}
              >
                {t(capitalize(item.language.toLowerCase())).toUpperCase()}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};
